import { render, staticRenderFns } from "./InvoicesServices.vue?vue&type=template&id=641fc33d&"
import script from "./InvoicesServices.vue?vue&type=script&lang=js&"
export * from "./InvoicesServices.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesServices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports